import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router, RouterEvent } from '@angular/router';
import { TranslocoService, TranslocoPipe } from '@jsverse/transloco';
import { filter, Observable } from 'rxjs';
import { Exposition } from '../../core/models';
import { MainService } from '../../core/services/main.service';
import { CommonModule } from '@angular/common';
import { TranslocoDatePipe } from '@jsverse/transloco-locale';

@Component({
    selector: 'expo-nav',
	standalone: true,
	imports: [CommonModule, TranslocoDatePipe, TranslocoPipe],
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.css'],
})
export class ExpoNavComponent implements OnInit {

	@Output() onOpenScheduleEvent: EventEmitter<any> = new EventEmitter<{}>();

	scheduledDate$: Observable<Date>;

	isScheduler: boolean = false;
	isSchedule: boolean = false;

	scheduledTime: Date;

	page: string;

	exposition: Exposition;

	constructor(
		private mainService: MainService,
		private router: Router,
		private route: ActivatedRoute,
		private translate: TranslocoService
	) {
		this.router.events.pipe(takeUntilDestroyed(), filter(event => event instanceof NavigationEnd)).subscribe(event => {
			this.page = (event as RouterEvent).url.split('/')[4];
			if (this.page != 'checkout' && this.page != 'order') this.page = 'other';
		});
	}

	ngOnInit(): void {
		this.exposition = this.route.snapshot.data['exposition'];
		this.scheduledDate$ = this.mainService.scheduledDateLoaded$;
		this.scheduledDate$.subscribe((scheduledDate: Date) => this.scheduledTime = scheduledDate);
	}

	showSchedule() {
		this.isSchedule = !this.isSchedule;
	}

	onClickRadishLogo() {
        this.router.navigate([this.translate.getActiveLang + '/expo/' + this.exposition.slug])
        .then(() => {
            window.location.reload();
        });
	}
}
